import { useL10n } from '@uplift/hooks';
import { MaskedInput, TextInput } from '@uplift/ui-v2';
import { Form } from 'formik';
import { useFormStyles } from '../form-styles';

export const EmergencyContactForm = () => {
  const l10n = useL10n();
  const { classes } = useFormStyles();

  return (
    <Form className={classes.formGroup}>
      <TextInput
        autoFocus
        label={l10n.accountSettings.profile.fullName}
        name="name"
        fullWidth
      />
      <TextInput
        label={l10n.accountSettings.profile.relationshipToYou}
        name="relationship"
        fullWidth
      />
      <MaskedInput
        label={l10n.accountSettings.profile.mobilePhone}
        name="phone"
        fullWidth
        type="phone"
        inputProps={{ inputMode: 'tel' }}
      />
    </Form>
  );
};
